var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""}},[_c('v-icon',{attrs:{"color":"teal"},on:{"click":function($event){return _vm.setData()}}},[_vm._v("edit")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }